import { ColumnViewModel } from '../../shared/column-types';

export const DISEASES_VDA_EVIDENCE: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiIDs',
    'variantStrID',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'mostSevereConsequences',
    'gof_lof',
    'chemical_effect',
    'associationType',
    'ancestry_name',
    'disease_model_in_doc',
    'sex_in_doc',
    'sentenceHTML',
    'text',
    'chemsInSentence',
    'chemIDs',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'source',
    'variantDSI',
    'variantDPI',
    'pValue',
    'chromosome',
    'coord',
    'alleleFreqExome',
    'alleleFreqGenome',
    'riskAllele',
    'DBSNPclass',
    'beta',
    'odds_ratio',
    'clinical_significance',
    'association',
    'citation_count',
    'icite_apt',
  ],
  defaultVisible: [
    'geneSymbol',
    'variantStrID',
    'score',
    'sourceScore',
    'gof_lof',
    'associationType',
    'ancestry_name',
    'disease_model_in_doc',
    'sex_in_doc',
    'sentenceHTML',
    'chemsInSentence',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'riskAllele',
    'beta',
    'odds_ratio',
  ],
};